module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro2--swiss-fb26ffdabc5dac6d83d46659e1bb3e45.jpg";